import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { ImageDialog } from 'components/common/ImageDialog';
import { HoverButton } from 'components/common/material-ui/custom-components';
import { useFieldError } from 'libs/content/hooks';
import { EditIcon, HoverButtonContainer, ImageContainer, ImagePlaceholder, Img, MaxSizeInfo, PlusIcon, SizeInfo, TrashIcon } from './ImageInput.style';

var ImageInput = function ImageInput(_ref) {
  var name = _ref.name,
      labelId = _ref.labelId,
      recommendedWidth = _ref.recommendedWidth,
      ratio = _ref.ratio,
      _ref$constraints = _ref.constraints,
      constraints = _ref$constraints === void 0 ? {
    maxWidth: 3000
  } : _ref$constraints,
      defaultValue = _ref.defaultValue,
      setImage = _ref.setImage;
  var maxWidth = constraints.maxWidth;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(false),
      isHovered = _useState2[0],
      setHover = _useState2[1];

  var imageRatio = ratio.width / ratio.height;
  var errorMessage = useFieldError(name);

  var handleImageUpdate = function handleImageUpdate(imageData) {
    if (setImage !== undefined) {
      setImage(_objectSpread(_objectSpread({}, imageData), {}, {
        imgUrl: (imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) === '' ? undefined : imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl
      }));
    }
  };

  var handleModalClose = function handleModalClose(imageData, onChange) {
    if ((imageData === null || imageData === void 0 ? void 0 : imageData.imgUrl) === '') {
      onChange({
        imgUrl: undefined,
        legend: '',
        credits: ''
      });
    }

    setIsOpen(false);
    handleImageUpdate(imageData);
  };

  var handleModalConfirm = function handleModalConfirm(imageData, onChange) {
    setIsOpen(false);
    onChange(imageData);
    handleImageUpdate(imageData);
  };

  var ImageInputControllerContent = function ImageInputControllerContent(_ref2) {
    var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        value = _ref2$field.value;
    return __jsx(FormControl, {
      variant: "outlined",
      error: Boolean(errorMessage)
    }, __jsx(ImageContainer, {
      ratio: imageRatio,
      onMouseOver: function onMouseOver() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      }
    }, isEmpty(value === null || value === void 0 ? void 0 : value.imgUrl) ? __jsx(ImagePlaceholder, {
      onClick: function onClick() {
        return setIsOpen(true);
      }
    }, __jsx(PlusIcon, null), __jsx(FormattedMessage, {
      id: "imageInput.placeholder"
    })) : __jsx(React.Fragment, null, __jsx(Img, {
      src: value.imgUrl,
      isHover: isHovered
    }), isHovered && __jsx(HoverButtonContainer, null, __jsx(HoverButton, {
      color: "primary",
      variant: "outlined",
      startIcon: __jsx(EditIcon, null),
      onClick: function onClick() {
        setIsOpen(true);
        setHover(false);
      }
    }, __jsx(FormattedMessage, {
      id: "imageInput.edit"
    })), __jsx(HoverButton, {
      color: "primary",
      variant: "outlined",
      startIcon: __jsx(TrashIcon, null),
      onClick: function onClick() {
        onChange({
          imgUrl: '',
          legend: '',
          credits: ''
        });
        setHover(false);
      }
    }, __jsx(FormattedMessage, {
      id: "imageInput.delete"
    }))))), __jsx(ImageDialog, {
      open: isOpen,
      initialData: value,
      onClose: function onClose() {
        return handleModalClose(value, onChange);
      },
      onConfirm: function onConfirm(imageData) {
        return handleModalConfirm(imageData, onChange);
      },
      imageRatio: imageRatio,
      imageConstraints: {
        constraints: constraints
      }
    }), __jsx(FormHelperText, null, errorMessage));
  };

  return __jsx(React.Fragment, null, __jsx(InputLabel, {
    error: Boolean(errorMessage)
  }, labelId !== undefined && __jsx(FormattedMessage, {
    id: labelId
  }), recommendedWidth !== undefined && __jsx(SizeInfo, null, "(", recommendedWidth, "x", recommendedWidth / imageRatio, ")")), __jsx("div", null, __jsx(MaxSizeInfo, null, __jsx(FormattedMessage, {
    id: "imageInput.maxLabel",
    values: {
      maxWidth: maxWidth,
      ratioWidth: ratio.width,
      ratioHeight: ratio.height
    }
  }))), __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : {},
    render: ImageInputControllerContent
  }));
};

export default ImageInput;